/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakInvitationStatus } from './StreakInvitationStatus';
import {
    StreakInvitationStatusFromJSON,
    StreakInvitationStatusFromJSONTyped,
    StreakInvitationStatusToJSON,
    StreakInvitationStatusToJSONTyped,
} from './StreakInvitationStatus';

/**
 * 
 * @export
 * @interface StreakInvitationResponse
 */
export interface StreakInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    fromDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    toDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    streakConfigId: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    streakConfigName?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakInvitationResponse
     */
    sharedGroupId: string;
    /**
     * 
     * @type {StreakInvitationStatus}
     * @memberof StreakInvitationResponse
     */
    status: StreakInvitationStatus;
    /**
     * 
     * @type {number}
     * @memberof StreakInvitationResponse
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof StreakInvitationResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof StreakInvitationResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the StreakInvitationResponse interface.
 */
export function instanceOfStreakInvitationResponse(value: object): value is StreakInvitationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fromUserId' in value) || value['fromUserId'] === undefined) return false;
    if (!('toUserId' in value) || value['toUserId'] === undefined) return false;
    if (!('streakConfigId' in value) || value['streakConfigId'] === undefined) return false;
    if (!('sharedGroupId' in value) || value['sharedGroupId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function StreakInvitationResponseFromJSON(json: any): StreakInvitationResponse {
    return StreakInvitationResponseFromJSONTyped(json, false);
}

export function StreakInvitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakInvitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fromUserId': json['fromUserId'],
        'toUserId': json['toUserId'],
        'fromDisplayName': json['fromDisplayName'] == null ? undefined : json['fromDisplayName'],
        'toDisplayName': json['toDisplayName'] == null ? undefined : json['toDisplayName'],
        'streakConfigId': json['streakConfigId'],
        'streakConfigName': json['streakConfigName'] == null ? undefined : json['streakConfigName'],
        'sharedGroupId': json['sharedGroupId'],
        'status': StreakInvitationStatusFromJSON(json['status']),
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function StreakInvitationResponseToJSON(json: any): StreakInvitationResponse {
    return StreakInvitationResponseToJSONTyped(json, false);
}

export function StreakInvitationResponseToJSONTyped(value?: StreakInvitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fromUserId': value['fromUserId'],
        'toUserId': value['toUserId'],
        'fromDisplayName': value['fromDisplayName'],
        'toDisplayName': value['toDisplayName'],
        'streakConfigId': value['streakConfigId'],
        'streakConfigName': value['streakConfigName'],
        'sharedGroupId': value['sharedGroupId'],
        'status': StreakInvitationStatusToJSON(value['status']),
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

